module.exports = __webpack_public_path__ + "img/melani-method-logo.07bb2e51.png";